export default {
    separator: ", ",
    contactUs: {
        form_name: "contact_us",
    },
    subscribeNewsletter: {
        form_name: "subscribe_to_newsletter",
    },
};
